// removed by extract-text-webpack-plugin
module.exports = {"mediaWrapper":"_9L7vY3mhqU_Vx3kGWUgM5","isLandingPage":"_2beiVsdJe69jzCnuqeb19D","childWrapper":"_1yEaxds-X_tSU7-oJvP2Qm","bottomAligned":"_1HFQS5zgAQwl9Jbfpwa5Ts"};


//////////////////
// WEBPACK FOOTER
// ./src/components/MediaWrapper/MediaWrapper.module.scss
// module id = 789
// module chunks = 0